import { render } from "./Register.vue?vue&type=template&id=2577de98&scoped=true"
import script from "./Register.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Register.vue?vue&type=script&charset=utf-8&lang=js"

import "./Register.vue?vue&type=style&index=0&id=2577de98&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2577de98"]])

export default __exports__